import { useRouter } from 'next/router'
import { type Locale, LocaleSelector } from 'pcl-ui'
import { track } from 'track'
import languageDetector from '@/utils/languageDetector'
import i18nextConfig from '../next-i18next.config'

const localeList: Locale[] = [
  { code: 'en', name: 'English', flag: '🇺🇸' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'ja', name: '日本語', flag: '🇯🇵' },
  { code: 'ko', name: '한국어', flag: '🇰🇷' },
  { code: 'pl', name: 'Polski', flag: '🇵🇱' },
  { code: 'pt', name: 'Português', flag: '🇵🇹' },
]

// Legacy tuple export for backward compatibility
export const locales: [string, string, string][] = localeList.map((l) => [
  l.code,
  l.name,
  l.flag,
])

export default function LocaleMenu({ bottom }: { bottom?: boolean }) {
  const router = useRouter()

  const changeLanguage = (lng: string) => {
    let pName = router.pathname
    track('event', 'change-language', {
      event_label: lng,
    })
    if (languageDetector.cache) languageDetector.cache(lng)

    if (router.query.slug) {
      router.push({
        pathname: '/[locale]/list/[slug]',
        query: { locale: lng, slug: router.query.slug },
      })
    } else if (
      lng === i18nextConfig.i18n.defaultLocale &&
      !router.query.contentId
    ) {
      pName = pName.replace('[locale]', '')
      router.push(pName)
    } else {
      if (router.query.contentId) {
        router.push({
          pathname: '/[locale]/[contentId]',
          query: { locale: lng, contentId: router.query.contentId },
        })
      } else if (router.asPath.includes('/articles')) {
        router.push({
          pathname: '/[locale]/articles',
          query: { locale: lng },
        })
      } else {
        router.push({
          pathname: '/[locale]',
          query: { locale: lng },
        })
      }
    }
  }

  const currentLocale =
    (router.query.locale as string) || i18nextConfig.i18n.defaultLocale

  return (
    <LocaleSelector
      locales={localeList}
      selected={currentLocale}
      onChange={changeLanguage}
      bottom={bottom}
    />
  )
}
